/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Loader from "../../components/Loader";
import { GlobalFilter } from "../../components/table/FilteringTable/GlobalFilter";
import { Table } from "antd";
import { columns } from "./components/utils";
import { deleteTenant, fetchAllTenant } from "../../../services/TenantService";
import swal from "sweetalert";
import TenantModal from "./components/TenantModal";

const TenantManagement = () => {
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [allTenants, setAllTenants] = useState([]);
  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [showAddModal, setShowAddModal] = useState(false);
  const [viewOrEdit, setViewOrEdit] = useState("none");
  const [selectedTenant, setSelectedTenant] = useState({});

  useEffect(() => {
    getAllRoles();
  }, []);

  const getAllRoles = () => {
    setLoading(true);
    fetchAllTenant({ page: tableParams?.current })
      .then((res) => {
        const response = res?.data?.result;
        console.log(response);
        setAllTenants(response?.data);
        setTableParams((prevTableParams) => ({
          ...prevTableParams,
          total: response?.count,
        }));
        setLoading(false);
      })
      .catch((error) => {
        // formatError(error.response?.data?.error);
        setLoading(false);
      });
  };
  const handleTableChange = (pagination) => {
    setTableParams(pagination);
  };

  const deleteHandler = (id) => {
    try {
      deleteTenant(id)
        .then((res) => {
          getAllRoles();
          swal("Success", "Role Deleted successfully", "success");
        })
        .catch((error) => {
          if (error.response.status === 403) {
            swal(
              "Not Authorize",
              "You are not Authorize to Delete role",
              "error"
            );
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  const onHideModal = () => {
    setShowAddModal(false);
  };

  const filterItems = allTenants?.filter((item) => {
    const isNameMatch =
      !searchTerm ||
      item?.Name?.toLowerCase().includes(searchTerm.toLowerCase());
    return isNameMatch;
  });

  return (
    <div class="card">
      {loading && <Loader forProcess={true} />}
      <div class="card-header d-sm-flex d-block">
        <div class="me-auto mb-sm-0">
          <h4 class="card-title">Tenant Management</h4>
        </div>
        <GlobalFilter filter={searchTerm} setFilter={setSearchTerm} />
        <button
          className="btn btn-info  light px-2 ms-4"
          onClick={() => {
            setViewOrEdit("none");
            setSelectedTenant({});
            setShowAddModal(true);
          }}
        >
          + Add New Tenant
        </button>
      </div>

      <div class="card-body">
        <Table
          columns={columns(
            setViewOrEdit,
            setShowAddModal,
            setSelectedTenant,
            tableParams,
            deleteHandler
          )}
          rowKey={(record) => record.id}
          dataSource={filterItems}
          pagination={tableParams}
          onChange={handleTableChange}
        />
      </div>

      {/* add modal */}
      <TenantModal
        onHideModal={onHideModal}
        showAddModal={showAddModal}
        viewOrEdit={viewOrEdit}
        selectedTenant={selectedTenant}
        getAllRoles={getAllRoles}
      />
    </div>
  );
};

export default TenantManagement;
